<template>
<div class="feature-field checkboxes-feature-field">
  <div v-for="featureValue in feature.values" class="checkboxes-feature-field-item">
    <div class="form-group">
      <label class="custom-checkbox">
        <span class="custom-checkbox-label">
          {{ featureValue.name }}
        </span>
        <input type="checkbox" :value="featureValue.id" v-model="valueAccessor">
        <span class="checkbox"></span>
      </label>
    </div>
  </div>
</div>
</template>

<script>
import AbstractFeatureField from './AbstractFeatureField'

export default AbstractFeatureField.extend({
  props: {
    value: Array,
  },
})
</script>

<style lang="less">
.checkboxes-feature-field {
    .checkboxes-feature-field-item {
        &:not(:first-child) {
            @apply mt-2;
        }
    }
}
</style>
